var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('navbar'),_c('div',{staticClass:"app-content-wrapper row no-gutters",style:({height: _vm.height})},[_c('sidebar',{staticClass:"sidebar-wrapper col-auto",style:({height: _vm.height})}),_c('app-main',{staticClass:"app-main-wrapper col",style:({height: _vm.height})})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }